// Utilidades para manejo consistente de fechas y timezone
const TIMEZONE = 'America/Argentina/Buenos_Aires';

export const formatTimestamp = (timestamp, options = {}) => {
  const date = new Date(timestamp);
  
  const defaultOptions = {
    timeZone: TIMEZONE,
    hour12: false
  };
  
  return date.toLocaleString('es-AR', { ...defaultOptions, ...options });
};

export const getChartTimeFormat = (data, groupBy = 'hour') => {
  if (!data || data.length === 0) return () => '';
  
  const firstTime = new Date(data[0].timestamp);
  const lastTime = new Date(data[data.length - 1].timestamp);
  const hoursDiff = (lastTime - firstTime) / (1000 * 60 * 60);
  
  // Determinar formato basado en rango temporal
  let formatOptions;
  if (groupBy === 'raw' && hoursDiff <= 2) {
    // Menos de 2 horas: mostrar hora:minuto:segundo
    formatOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit' };
  } else if (hoursDiff <= 24) {
    // Menos de 24 horas: mostrar hora:minuto
    formatOptions = { hour: '2-digit', minute: '2-digit' };
  } else if (hoursDiff <= 168) { // 7 días
    // 1-7 días: mostrar día/mes hora:minuto
    formatOptions = { 
      day: '2-digit', 
      month: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit' 
    };
  } else {
    // Más de 7 días: mostrar día/mes
    formatOptions = { day: '2-digit', month: '2-digit' };
  }
  
  // Determinar intervalo para evitar solapamiento
  const maxLabels = 15;
  const interval = Math.max(1, Math.floor(data.length / maxLabels));
  
  return (index) => {
    if (index % interval !== 0 && index !== 0 && index !== data.length - 1) {
      return ''; // Mostrar solo cada 'interval' etiquetas + primera y última
    }
    
    return formatTimestamp(data[index].timestamp, formatOptions);
  };
};

export const formatTooltipTime = (timestamp) => {
  return formatTimestamp(timestamp, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
};

export const adjustDateForTimezone = (dateString, isStart = true) => {
  // Convierte YYYY-MM-DD a un ISO UTC interpretando la fecha en zona horaria Argentina (UTC-3).
  // Usa offset explícito en el string para que el resultado sea independiente de la zona horaria del navegador
  // (antes se usaba `new Date(dateString + 'T00:00:00')` que se interpretaba como hora LOCAL del navegador,
  // produciendo un offset doble y perdiendo datos en los bordes del día).
  if (isStart) {
    // 00:00:00 hora Argentina = 03:00:00 UTC del mismo día
    return new Date(dateString + 'T00:00:00.000-03:00').toISOString();
  } else {
    // 23:59:59.999 hora Argentina = 02:59:59.999 UTC del día siguiente
    return new Date(dateString + 'T23:59:59.999-03:00').toISOString();
  }
};

export const getCurrentLocalDateString = (daysAgo = 0) => {
  // Obtener fecha en timezone de Argentina
  const now = new Date();
  const argentinaTime = new Date(now.toLocaleString("en-US", {timeZone: "America/Argentina/Buenos_Aires"}));
  argentinaTime.setDate(argentinaTime.getDate() - daysAgo);
  
  const year = argentinaTime.getFullYear();
  const month = String(argentinaTime.getMonth() + 1).padStart(2, '0');
  const day = String(argentinaTime.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Función de debug para verificar conversiones de fecha
export const debugDateConversion = (dateString, isStart = true) => {
  const original = dateString;
  const converted = adjustDateForTimezone(dateString, isStart);
  const backToLocal = formatTimestamp(converted, { 
    day: '2-digit', 
    month: '2-digit', 
    year: 'numeric',
    hour: '2-digit', 
    minute: '2-digit',
    second: '2-digit' 
  });
  
  console.log('🐛 Date Debug (Argentina Timezone Fixed):', {
    original: original,
    converted: converted,
    backToArgentina: backToLocal,
    isStart: isStart,
    timezone: 'America/Argentina/Buenos_Aires (UTC-3)',
    note: 'Frontend now properly converts Argentina time to UTC before sending to backend'
  });
  
  return converted;
};